import { render } from "./MaterialButton.vue?vue&type=template&id=7b03a5c5"
import script from "./MaterialButton.vue?vue&type=script&lang=js"
export * from "./MaterialButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/Portal/portal-partner-deploy-to-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__